import { useEffect } from 'react';
import { toast } from 'sonner';
import { useRouter } from 'next/router';
import Seo from '@/components/shared/Seo';
import MobileHomePage from '@/components/home/mobile/Dashboard/MobileHomePage';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import { useSession } from '@/contexts/LitSessionProvider';
import { useMixpanel } from '@/lib/misc/mixpanel';
import PortfolioLayout from '@/components/portfolio/desktop/PortfolioLayout';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
export default function PortfolioPage() {
  const {
    PKP
  } = useSession();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const router = useRouter();
  useEffect(() => {
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const message = urlParams.get('message');
    if (message) {
      toast(message);
      // Remove the message parameter
      urlParams.delete('message');

      // Update URL without the message parameter
      const newUrl = `${window.location.pathname}${urlParams?.toString() ? `?${urlParams?.toString()}` : ''}`;
      window.history.replaceState({}, '', newUrl);
    }
    const onramperSuccess = urlParams.get('onrampersuccess');
    if (onramperSuccess === 'true') {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.deposit.finalizeDeposit,
        category: CATEGORIES.deposit,
        metaData: {
          type: 'onramper'
        }
      });

      // Remove the 'onrampersuccess' parameter
      urlParams.delete('onrampersuccess');

      // Construct the new URL without the parameter
      const newUrl = url.origin + url.pathname + (urlParams?.toString() ? '?' + urlParams?.toString() : '');

      // Update the browser history without reloading the page
      window.history.replaceState({}, '', newUrl);
    }
  }, [router]);
  const isMobile = useIsMobile();
  return <div className='w-full' data-sentry-component="PortfolioPage" data-sentry-source-file="index.tsx">
      <Seo nofollow noindex title='Portfolio • Genius Terminal • Trade Crypto Like a Genius' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />
      {isMobile ? <FullScreenGuard>
          <MobileHomePage className='lg:hidden overflow-x-hidden' />
        </FullScreenGuard> : <PortfolioLayout />}
    </div>;
}